import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"

const HowItWorks = ({ data }) => {
  return (
    <React.Fragment>
      <div
        style={{ background: `rgb(146, 154, 153)` }}
        className=" row align-items-center"
      >
        <div className="col-12 col-md-6 mt-5">
          <div className="container text-white px-auto">
            <h2 className=" text-uppercase">How It Works</h2>
            <p>
              Because I know you've got better things to do than be confused
            </p>
            <ol className="h5 pl-4">
              <li>
                <Link
                  style={{ background: `rgba(255, 255, 255, 0.5)` }}
                  className="text-white p-1"
                  to="/contact"
                >
                  Fill Out Contact Form
                </Link>
              </li>
              <li>Set up a time to chat</li>
              <li>Become Best Friends</li>
              <li>Book Your Dream Photographer</li>
            </ol>
          </div>
        </div>
        <div className="col-12 col-md-6 mt-4 mt-md-0">
          <Img fluid={data.childImageSharp.fluid} />
        </div>
      </div>
    </React.Fragment>
  )
}

export default HowItWorks
